import type { AppData } from '../page';
import type { Maybe } from '../type';
import type { RootData } from '~/root';

// BB-3514: structural matches type — react-router v7's MetaMatches<M> is invariant
// in the loader type, so accepting the concrete typed matches from any meta arg
// (rather than a fixed MetaArgs<_, StaticParentLoaders>) avoids generic-variance
// errors at every call site. Only `.id` / `.data` are read here.
export const getRouteData = (
    matches: ReadonlyArray<{ id: string; data: unknown }>,
) => {
    const rootData = matches.find((match) => match.id === 'root')
        ?.data as Maybe<RootData>;
    const appData = matches.find((match) => match.id === 'routes/_app')
        ?.data as Maybe<AppData>;

    return {
        rootData,
        appData,
    };
};
